import http from "./http";

function get_slot_data(data) {
  return http.post(`getSlotList`, data);
}
function add_slot_data(data) {
  return http.post(`saveSlot`, data);
}
function update_slot_data(data) {
  return http.post(`updateSlot`, data);
}

const TimeSlotService = {
  get_slot_data,
  add_slot_data,
  update_slot_data,
};

export default TimeSlotService;
